import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Receipt, BookOpen, BarChart3, Settings } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

const MobileLayout = ({ children }) => {
    const { t } = useLanguage();
    const location = useLocation();

    const navItems = [
        { path: '/', icon: Home, label: t('home') },
        { path: '/transactions', icon: Receipt, label: t('transactions') },
        { path: '/khata', icon: BookOpen, label: t('khata') },
        { path: '/reports', icon: BarChart3, label: t('reports') },
        { path: '/settings', icon: Settings, label: t('settings') },
    ];

    return (
        <div className="min-h-screen bg-background pb-20">
            {/* Main Content */}
            <main className="max-w-md mx-auto px-4 py-4 safe-area-top">
                {children}
            </main>

            {/* Bottom Navigation */}
            <nav className="bottom-nav safe-area-bottom" data-testid="bottom-navigation">
                <div className="flex items-center justify-around h-full max-w-md mx-auto">
                    {navItems.map((item) => {
                        const isActive = location.pathname === item.path || 
                            (item.path !== '/' && location.pathname.startsWith(item.path));
                        
                        return (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                data-testid={`nav-${item.path.replace('/', '') || 'home'}`}
                                className={cn(
                                    "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all relative touch-target",
                                    isActive 
                                        ? "text-primary" 
                                        : "text-muted-foreground hover:text-foreground"
                                )}
                            >
                                {isActive && (
                                    <span className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-1 bg-primary rounded-b-full" />
                                )}
                                <item.icon className="h-5 w-5" />
                                <span className="text-xs font-medium">{item.label}</span>
                            </NavLink>
                        );
                    })}
                </div>
            </nav>
        </div>
    );
};

export default MobileLayout;
